export const quote_costs_displayed_columns_locale = {
  name: "Name",
  partyDescription: "Party",
  quantity: "Quantity",
  priceExclVat: "Price",
  totalExclVat: "Total excl. VAT",
  totalExclVatExchangeRateApplied: "Total"
};
